import React from "react";
import { Empty } from "@arco-design/web-react";

// EmptyState is Arco's Empty with room for a button. Empty itself ignores
// anything placed inside it, so a button there never shows.
export default function EmptyState({ description, children, style }) {
  return (
    <div style={style}>
      <Empty description={description} />
      {children && <div style={{ textAlign: "center" }}>{children}</div>}
    </div>
  );
}
